import React, { useEffect, useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import Alljobs from "./Alljobs";
import Gotop from "../../components/gotop";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import CRHeader from "../../components/header/CRHeader";
import { useLocation } from "react-router-dom";
import axios from "../../API/axios";

const Searchjobs = () => {
  const [searchjobName, setSearchjobName] = useState("");
  const [selectedcompaniesId, setSelectedcompaniesId] = useState(null);
  const [selectedcityId, setSelectedcityId] = useState(null);
  const [selectedJobTypeId, setSelectedJobTypeId] = useState(null);
  const [selectedworkLevelId, setSelectedworkLevelId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedDesignationId, setSelectedDesignationId] = useState(null);
  const [selectedSalaryTypeId, setSelectedSalaryTypeId] = useState(null);
  const [jobList, setjobList] = useState([]);
  const module = localStorage.getItem("Module");
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const [searchjobList, setSearchjobList] = useState([]);
  const [isShowMobile, setShowMobile] = useState(false);

  // Extract query parameters from the URL
  // useEffect(() => {
  //   const fetchParamsFromUrl = () => {

  //     setSearchjobName(queryParams.get("search") || "");
  //     setSelectedcompaniesId(queryParams.get("compName") || null);
  //     setSelectedcityId(queryParams.get("cityId") || null);
  //     setSelectedJobTypeId(queryParams.get("jbTypId") || null);
  //     setSelectedworkLevelId(queryParams.get("workLevelType") || null);
  //     setSelectedCategoryId(queryParams.get("workLocationTypeId") || null);
  //     setSelectedDesignationId(queryParams.get("designationId") || null);
  //     setSelectedSalaryTypeId(queryParams.get("salaryTypeId") || null);
  //   };

  //   fetchParamsFromUrl();
  // }); 

  useEffect(() => {
    const fetchParamsFromUrl = () => {
      setSearchjobName(queryParams.get("search") || "");
      setSelectedcompaniesId(queryParams.get("compName") || null);
      setSelectedcityId(queryParams.get("cityId") || null);
      setSelectedJobTypeId(queryParams.get("jbTypId") || null);
      setSelectedworkLevelId(queryParams.get("workLevelType") || null);
      setSelectedCategoryId(queryParams.get("workLocationTypeId") || null);
      setSelectedDesignationId(queryParams.get("designationId") || null);
      setSelectedSalaryTypeId(queryParams.get("salaryTypeId") || null);
    };
  
    fetchParamsFromUrl();
  }, [search]); 

  const getAlljobList = (page) => { 

    const data = {
      pageNumber: page,
      pageSize: 20,
      search: searchjobName,
      compId : selectedcompaniesId,
      cityId: selectedcityId,
      jbTypId: selectedJobTypeId,
      workLevelType: selectedworkLevelId,
      workLocationTypeId: selectedCategoryId,
      designationId: selectedDesignationId,
      salaryTypeId: selectedSalaryTypeId,
    };
    console.log("");

    axios
      .post(`/Job/GetAll`, data)
      .then((response) => {
        const res = response.data.responseData.jobsList; 

        setjobList(res); 

        const newPosts = response.data.responseData.jobsList;
        if (searchjobName !== "") {
          setjobList([]);
          setSearchjobList(newPosts);
        } else {
          setSearchjobList([]);
          setjobList((prev) => {
            const jobSet = new Set(prev?.map((job) => job?.uid));
            const uniqueNewPosts = newPosts.filter(
              (job) => !jobSet.has(job?.uid)
            );
            return [...prev, ...uniqueNewPosts];
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
        } else {
          console.log(error);
        }
      });
  };

  // Call the API function when the component loads or query parameters change
  useEffect(() => {
    getAlljobList(1);
    setjobList([]); // Fetch jobs for the first page
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    searchjobName,
    selectedcompaniesId,
    selectedcityId,
    selectedJobTypeId,
    selectedworkLevelId,
    selectedCategoryId,
    selectedDesignationId,
    selectedSalaryTypeId,
  ]); 

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  return (
    <>
      {module === "Candidate" ? (
        <LoginMobileHeader handleMobile={handleMobile} />
      ) : module === "Institution" ? (
        <InstituteMobileHeader handleMobile={handleMobile} />
      ) : module === "Company" ? (
        <CRMobileHeader handleMobile={handleMobile} />
      ) : module === "Recruiter" ? (
        <CRMobileHeader handleMobile={handleMobile} />
      ) : (
        <MobileHeader handleMobile={handleMobile} />
      )}

      {module === "Candidate" ? (
        <LoginHeader clname="searchjobheader" handleMobile={handleMobile} />
      ) : module === "Institution" ? (
        <InstituteHeader clname="searchjobheader" handleMobile={handleMobile} />
      ) : module === "Company" ? (
        <CRHeader clname="searchjobheader" handleMobile={handleMobile} />
      ) : module === "Recruiter" ? (
        <CRHeader clname="searchjobheader" handleMobile={handleMobile} />
      ) : (
        <NonLoginHeader clname="searchjobheader" handleMobile={handleMobile} />
      )}

      <div className="pt-70">
        <Alljobs
          className="jobs-section"
          searchjobName={searchjobName}
          setSearchjobName={setSearchjobName}
          jobList={jobList}
          searchjobList={searchjobList}
          setjobList={setjobList}
        />
        <Gotop />
      </div>
    </>
  );
};

export default Searchjobs;
